import {ChecksMiniStatus, ChecksMiniStatusBoundary} from './mini-merge-sections/ChecksMiniStatus'
import {ApprovalsMiniStatus, ApprovalsMiniStatusBoundary} from './mini-merge-sections/ApprovalsMiniStatus'
import {CommentsMiniStatus, CommentsMiniStatusBoundary} from './mini-merge-sections/CommentsMiniStatus'
import styles from './mini-merge-sections/MiniMergeSections.module.css'
import {Stack} from '@primer/react'
import {useState} from 'react'
import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PendingChecksBody} from './shared/PendingChecksBody'
import {useMergeabilityData} from './use-mergeability-data'

export function MiniOverviewMergeStatus() {
  const state = usePullRequestState()
  const [isChecksExpanded, setIsChecksExpanded] = useState(false)

  if (state === 'MERGED' || state === 'CLOSED') {
    return null
  }

  return (
    <div className={styles.MiniStatusGrid}>
      <Stack
        as="section"
        direction={{narrow: 'vertical', regular: 'horizontal'}}
        className={styles.MiniStatusWrapper}
        gap="none"
        aria-label="Merge status"
      >
        <ChecksMiniStatusBoundary>
          <ChecksMiniStatus expanded={isChecksExpanded} onToggle={() => setIsChecksExpanded(value => !value)} />
        </ChecksMiniStatusBoundary>

        <CommentsMiniStatusBoundary>
          <CommentsMiniStatus />
        </CommentsMiniStatusBoundary>

        <ApprovalsMiniStatusBoundary>
          <ApprovalsMiniStatus />
        </ApprovalsMiniStatusBoundary>
      </Stack>
      {isChecksExpanded ? <ExpandedChecksSection /> : null}
    </div>
  )
}

function ExpandedChecksSection() {
  const data = useMergeabilityData()
  if (!data) return null

  return (
    <PendingChecksBody
      data={data}
      itemName="mini-checks"
      emptyMessage="No checks have been reported for this pull request yet."
    />
  )
}
